export const routes = {
    DEFAULT: '/',
    MATERIALS: '/materials',
    GRAPH: '/graph',
    GRAPH_CONCEPT: '/graph/concept',
    GRAPH_PREVIEW: '/graph/preview',
    MORE: '/more',
} as const;
